import React from 'react';
import { generatePath, useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import { API_SOLUTION_GROUP_DELETE } from '../../constants';
import solutionsStore from '../../redux';
import { SolutionGroupItem } from '../../types';

type Props = {
  item: SolutionGroupItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionGroupsDeleteModal({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();

  const [handleRemove, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generatePath(API_SOLUTION_GROUP_DELETE, {
          solutionId,
          groupId: item?.id,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'solution group deleted',
        text: `${item?.name || ''} group has been deleted successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <ModalDialog
      open={open}
      title={`Delete Group: ${item?.name}`}
      text="Are you sure you want to delete this group?"
      loading={loading}
      onClose={onClose}
      onConfirm={handleRemove}
      cancelBtnText="No"
      confirmBtnText="Yes"
    />
  );
}

export default SolutionGroupsDeleteModal;
